/*
 * Soulax logo, ported from the official brand SVG (soulax.io).
 * The navy glyph/wordmark paths use `currentColor` so the mark recolors with
 * `color:` (brand navy by default); the orange stroke stays fixed #FF7836.
 */

// The interlocking-arrow mark (icon only), no wordmark.
const MARK_NAVY = [
  'M10.33 35.0454L12.1498 33.3066L29.2799 51.3757L27.4601 53.1145L10.33 35.0454Z',
  'M12.7023 32.7788L14.2296 31.3195L31.3597 49.3885L29.8324 50.8478L12.7023 32.7788Z',
  'M14.7821 30.7916L16.3419 29.3012L33.472 47.3703L31.9121 48.8607L14.7821 30.7916Z',
  'M16.8943 28.7734L18.4217 27.3141L35.5518 45.3831L34.0244 46.8424L16.8943 28.7734Z',
  'M18.9741 26.7862L20.7289 25.1095L37.859 43.1786L36.1042 44.8552L18.9741 26.7862Z',
  'M21.2814 24.5817L23.0362 22.905L40.1663 40.974L38.4115 42.6507L21.2814 24.5817Z',
  'M23.826 22.3042L25.5606 20.6029L42.647 38.6258L40.7297 40.4577L23.826 22.3042Z',
  'M26.0584 20.0174L27.7821 18.3776L45.0083 36.3476L43.1885 38.0864L26.0584 20.0174Z',
  'M27.4801 53.1355L25.7485 51.3091L43.2967 34.5423L45.0283 36.3687L27.4801 53.1355Z',
]
const MARK_ORANGE = [
  'M44.6705 18.7226L42.8507 20.4614L25.7206 2.39238L27.5404 0.653595L44.6705 18.7226Z',
  'M42.2982 20.9893L40.7709 22.4486L23.6408 4.37956L25.1682 2.92022L42.2982 20.9893Z',
  'M40.2185 22.9764L38.6586 24.4668L21.5285 6.39778L23.0884 4.9074L40.2185 22.9764Z',
  'M38.1062 24.9947L36.5788 26.454L19.4488 8.38496L20.9761 6.92563L38.1062 24.9947Z',
  'M36.0167 26.9716L34.2631 28.6861L17.1318 10.5793L18.8866 8.9026L36.0167 26.9716Z',
  'M33.7175 29.2L31.9161 30.997L14.8342 12.794L16.5891 11.1173L33.7175 29.2Z',
  'M31.2532 31.573L29.498 33.2452L12.3536 15.1423L14.2709 13.3103L31.2532 31.573Z',
  'M28.9071 33.7358L27.1908 35.4525L9.95944 17.3858L11.7793 15.647L28.9071 33.7358Z',
  'M27.5114 0.622958L29.2429 2.44943L11.6948 19.2163L9.96319 17.3898L27.5114 0.622958Z',
]
// The "Soulax" wordmark letters (navy).
const WORDMARK = [
  'M60.8537 35.2178C57.8051 35.2178 54.7292 34.3104 53.0264 32.9905L54.5369 29.6358C56.1573 30.8182 58.5741 31.6431 60.8811 31.6431C63.5177 31.6431 64.5888 30.7632 64.5888 29.5808C64.5888 25.9786 53.4109 28.4534 53.4109 21.304C53.4109 18.0318 56.0474 15.3096 61.5128 15.3096C63.9297 15.3096 66.4015 15.887 68.1866 17.0144L66.8134 20.3966C65.0282 19.3792 63.1881 18.8843 61.4854 18.8843C58.8488 18.8843 57.8326 19.8742 57.8326 21.0841C57.8326 24.6312 69.0106 22.184 69.0106 29.2508C69.0106 32.468 66.3465 35.2178 60.8537 35.2178Z',
  'M81.3611 35.2178C75.2915 35.2178 70.8423 30.9832 70.8423 25.2637C70.8423 19.5442 75.2915 15.3096 81.3611 15.3096C87.4032 15.3096 91.8799 19.5167 91.8799 25.2637C91.8799 31.0107 87.4032 35.2178 81.3611 35.2178ZM81.3611 31.4231C84.7941 31.4231 87.3758 28.9209 87.3758 25.2637C87.3758 21.6065 84.7941 19.1042 81.3611 19.1042C77.9281 19.1042 75.3464 21.6065 75.3464 25.2637C75.3464 28.9209 77.9281 31.4231 81.3611 31.4231Z',
  'M103.765 35.2178C98.2997 35.2178 95.0589 32.0831 95.0589 26.4186V15.6395H99.5081V26.2536C99.5081 29.9108 101.101 31.4231 103.793 31.4231C106.511 31.4231 108.077 29.9108 108.077 26.2536V15.6395H112.471V26.4186C112.471 32.0831 109.23 35.2178 103.765 35.2178Z',
  'M116.868 34.8878V15.6395H121.317V31.2582H130.957V34.8878H116.868Z',
  'M147.968 34.8878L146.265 30.7632H137.339L135.636 34.8878H131.077L139.646 15.6395H144.04L152.637 34.8878H147.968ZM138.767 27.381H144.864L141.816 20.0117L138.767 27.381Z',
  'M170.886 34.8878H165.751L161.109 28.2059L156.55 34.8878H151.442L158.555 25.0987L151.799 15.6395H156.852L161.274 21.8815L165.613 15.6395H170.419L163.718 24.9337L170.886 34.8878Z',
]

const ORANGE = '#FF7836'

type IconProps = { className?: string; title?: string }

/** Rehrig mark from `public/logo.svg` (navy tile + white R). */
export function Logo({
  className,
  title = 'Rehrig Pacific',
  width,
  height,
}: IconProps & { width?: number; height?: number }) {
  return (
    <img
      src="/logo.svg"
      alt={title}
      width={width}
      height={height}
      className={className}
      decoding="async"
      fetchPriority="high"
      loading="eager"
    />
  )
}

export function SoulaxMark({ className, title = 'Soulax' }: IconProps) {
  return (
    <svg
      viewBox="9 0 37 54"
      fill="none"
      role="img"
      aria-label={title}
      className={className}
    >
      {MARK_NAVY.map((d) => (
        <path key={d} d={d} fill="currentColor" />
      ))}
      {MARK_ORANGE.map((d) => (
        <path key={d} d={d} fill={ORANGE} />
      ))}
    </svg>
  )
}

export function SoulaxWordmark({ className, title = 'Soulax' }: IconProps) {
  return (
    <svg
      viewBox="0 0 192 53"
      fill="none"
      role="img"
      aria-label={title}
      className={className}
    >
      {MARK_NAVY.map((d) => (
        <path key={d} d={d} fill="currentColor" />
      ))}
      {MARK_ORANGE.map((d) => (
        <path key={d} d={d} fill={ORANGE} />
      ))}
      {WORDMARK.map((d) => (
        <path key={d} d={d} fill="currentColor" />
      ))}
    </svg>
  )
}
